/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1266
 */

var r = require(/* 634 */"../../1774/1253/634")
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(r)
